import type { GetUserParams, GetUserResult } from '../../domain/models/get-user'
import type { IGetUser } from '../../domain/use-cases/i-get-user'

export class GetUserController {
  constructor(private readonly repository: IGetUser) {}

  async get(params: GetUserParams): Promise<GetUserResult> {
    try {
      const result = await this.repository.get(params)

      return result
    } catch (error) {
      throw error
    }
  }
}
